export const generateBreadCrumbs = (role: any) => ({
  result: {
    department: role?.department?.name,
    deliverable: role?.deliverable?.name,
    component: role?.component?.name,
    name: role?.name,
  },
})
